export const GET_RANKING_DETAIL_SUCCESS = 'GET_RANKING_DETAIL_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
